import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

import {
  EventWhen,
  PriceRangeIndications,
  LinkMore,
  ListingImage,
} from '@package/components';

const ListTemplate = (data) => {
  const { items, isEditMode } = data;

  return items.length > 0 ? (
    <div className="list-template">
      {items.map((item) => {
        const infos =
          item['@type'] === 'Event' ? (
            <div className="item-info">
              {item.date_text ? (
                <p className="item-data">{item.date_text}</p>
              ) : (
                <EventWhen
                  start={item.start}
                  end={item.end}
                  whole_day={item.whole_day}
                  open_end={item.open_end}
                  show_times={false}
                />
              )}
            </div>
          ) : null;

        //tronca la descrizione se troppo lunga
        let description = item.description;
        if (description?.length > 200) {
          description = description.substring(0, 85) + '...';
        }
        return (
          <div className="item" key={item['@id']}>
            <div className="image">
              <PriceRangeIndications item={item} />
              <ConditionalLink
                to={flattenToAppURL(item['@id'])}
                condition={!isEditMode}
                aria-hidden="true"
                role="presentation"
                tabIndex="-1"
              >
                <ListingImage item={item} />
              </ConditionalLink>
            </div>
            <div className="content">
              {item.description_card && (
                <div className="item-description-card">
                  {item.description_card}
                </div>
              )}
              <div className="item-title">
                <ConditionalLink
                  to={flattenToAppURL(item['@id'])}
                  condition={!isEditMode}
                >
                  {infos}
                  {item.title ? item.title : item.id}
                </ConditionalLink>
              </div>
              {description && (
                <div className="item-description">{description}</div>
              )}
              {item['@type'] === 'Esperienza' && item.municipality?.title && (
                <div className="municipality">{item.municipality.title}</div>
              )}
              {item['@type'] === 'Event' && item.location_text && (
                <div className="municipality">{item.location_text}</div>
              )}
            </div>
          </div>
        );
      })}

      <LinkMore {...data} />
    </div>
  ) : null;
};

ListTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default ListTemplate;
